import { useState } from 'react';

import {
    DoorOpen,
    DoorClosedLocked,
    Clock,
} from 'lucide-react';
import { useDevice } from '../../hooks/useDevices';

import { Icon } from '../../components/Icon';



interface DoorStates {
    [key: number]: boolean;
}

interface DoorProgress {
    [key: number]: number;
}

const Puertas = () => {
    // Datos de ejemplo para las cards
    const [doorStates, setDoorStates] = useState<DoorStates>({});
    const [doorProgress, setDoorProgress] = useState<DoorProgress>({});


    const { data, openDoor } = useDevice();

    // const handleDoorAction = (cardId: Number, title: string) => {
    //     alert(`Acción de puerta ejecutada para: ${title} - ${cardId}`);
    // };

    const getStatusColor = (status: boolean) => {
        switch (status) {
            case true: return 'text-green-500 dark:text-green-400';
            case false: return 'text-red-500 dark:text-red-400';
            default: return 'text-gray-500 dark:text-gray-400';
        }
    };

    const getStatusText = (status: boolean) => {
        switch (status) {
            case true: return 'Activo';
            case false: return 'Inactivo';
            default: return 'Desconocido';
        }
    };

    const handleDoorAction = (cardId: number) => {
        if (doorStates[cardId]) return; 

        openDoor(cardId)
        

        // Cambiar estado a abierto
        setDoorStates(prev => ({ ...prev, [cardId]: true }));
        setDoorProgress(prev => ({ ...prev, [cardId]: 100 }));

        // Progress bar countdown
        const interval = setInterval(() => {
            setDoorProgress(prev => {
                const currentProgress = prev[cardId] || 0;
                const newProgress = Math.max(0, currentProgress - 1);

                if (newProgress <= 0) {
                    clearInterval(interval);
                    // Volver al estado cerrado después del countdown
                    setTimeout(() => {
                        setDoorStates(prevStates => ({ ...prevStates, [cardId]: false }));
                        setDoorProgress(prevProgress => ({ ...prevProgress, [cardId]: 0 }));
                    }, 100);
                }

                return { ...prev, [cardId]: newProgress };
            });
        }, 100); // 100ms = 10 segundos total
    };

    return (
        <div className="max-w-4xl mx-auto p-2 space-y-4">
            <div className="mb-6">
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
                    Control de Accesos
                </h2>
                <p className="text-gray-600 dark:text-gray-400">
                    Gestiona los puntos de acceso del edificio
                </p>
            </div>

            {/* Lista de Cards */}
            <div className="space-y-3">


                {data.map((item) => {
                    // const Icon = item.icon;

                    return (
                        <div
                            key={item.devices_id}
                            className={`bg-white dark:bg-gray-800 rounded-xl shadow-sm hover:shadow-md dark:shadow-gray-900/20 border ${doorStates[item.devices_id]
                                ? 'border-green-600 dark:border-green-900 border-2' : 'border-gray-200 dark:border-gray-700'}  transition-all duration-200 hover:scale-[1.01]`}
                        >
                            <div className="p-4 sm:p-6">
                                <div className="flex items-center justify-between">
                                    {/* Lado izquierdo - Icono y contenido */}
                                    <div className="flex items-center space-x-4 min-w-0 flex-1">
                                        {/* Icono */}
                                        <div className={`flex-shrink-0 w-12 h-12 rounded-xl bg-blue-50 dark:bg-gray-900/20 flex items-center justify-center`}>
                                            <Icon name={"facial"} className={`w-6 h-6 text-primary dark:text-gray-400`} />
                                        </div>

                                        {/* Contenido de texto */}
                                        <div className="min-w-0 flex-1">
                                            {/* Título y status en la misma línea */}
                                            <div className="flex items-center space-x-3 mb-1">
                                                <h3 className="text-lg font-semibold text-gray-900 dark:text-white truncate">
                                                    {item.name_device}
                                                </h3>
                                                <span className="flex items-center">
                                                    <div className={`w-2 h-2 rounded-full ${getStatusColor(item.status).replace('text-', 'bg-')} mr-2`}></div>
                                                    <span className={`text-sm font-medium ${getStatusColor(item.status)} hidden sm:inline`}>
                                                        {getStatusText(item.status)}
                                                    </span>
                                                </span>
                                            </div>

                                            {/* Subtítulo */}
                                            <p className="text-sm font-medium text-gray-600 dark:text-gray-300 mb-1">
                                                {item.types_devices_id}
                                            </p>

                                            {/* Descripción */}
                                            <p className="text-sm text-gray-500 dark:text-gray-400 truncate">
                                                {item.ip_address}
                                            </p>
                                        </div>
                                    </div>

                                    {/* Lado derecho - Botón de puerta */}
                                    <div className="flex-shrink-0 ml-4 relative">
                                        <button
                                            onClick={() => handleDoorAction(item.devices_id)}
                                            disabled={doorStates[item.devices_id]}
                                            className={`w-12 h-12 sm:w-14 sm:h-14 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 flex items-center justify-center group active:scale-95 relative ${doorStates[item.devices_id]
                                                ? 'bg-green-600 hover:bg-green-700 dark:bg-green-500 dark:hover:bg-green-600'
                                                : 'bg-red-600 hover:bg-red-700 dark:bg-red-500 dark:hover:bg-red-600'
                                                } text-white`}
                                            title={doorStates[item.devices_id] ? "Puerta abierta" : "Abrir puerta"}
                                        >
                                            {doorStates[item.devices_id] ? (
                                                <DoorOpen className="w-5 h-5 sm:w-6 sm:h-6 group-hover:scale-110 transition-transform" />
                                            ) : (
                                                <DoorClosedLocked className="w-5 h-5 sm:w-6 sm:h-6 group-hover:scale-110 transition-transform" />
                                            )}



                                            {/* Progress bar circular */}
                                            {doorStates[item.devices_id] && (
                                                <svg
                                                    className="absolute inset-0 w-full h-full -rotate-90"
                                                    viewBox="0 0 100 100"
                                                >
                                                    <circle
                                                        cx="50"
                                                        cy="50"
                                                        r="48"
                                                        fill="transparent"
                                                        stroke="rgba(255,255,255,0.3)"
                                                        strokeWidth="4"
                                                    />
                                                    <circle
                                                        cx="50"
                                                        cy="50"
                                                        r="48"
                                                        fill="transparent"
                                                        stroke="white"
                                                        strokeWidth="4"
                                                        strokeDasharray="301.59"
                                                        strokeDashoffset={301.59 * (1 - (doorProgress[item.devices_id] || 0) / 100)}
                                                        className="transition-all duration-100 ease-linear"
                                                    />
                                                </svg>
                                            )}
                                        </button>
                                    </div>
                                </div>

                                {/* Información adicional en móvil */}
                                <div className="mt-4 pt-4 border-t border-gray-100 dark:border-gray-700 sm:hidden">
                                    <div className="flex items-center justify-between text-sm">
                                        <span className="flex items-center text-gray-500 dark:text-gray-400">
                                            <Clock className="w-4 h-4 mr-1" />
                                            Último acceso
                                        </span>
                                        <span className="text-gray-600 dark:text-gray-300 font-medium">
                                            {item.status ? '09:45 AM' : 'N/A'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>

        </div>
    );
};

export default Puertas;